export default __webpack_public_path__ + "static/media/link_ico.a9a5c84c.svg";